import { useEffect, useState } from 'react';
import { fetchMe } from './users-admin';

// Module-scoped promise so GET /me fires at most once per page load even if
// useMe is consumed in multiple places (App tab gating + UsersPanel).
let cached = null;

/**
 * The caller's resolved RBAC view from GET /api/me:
 *   { role, organisationId, permissions, allowedModels, isAdmin, isSuperAdmin, assignableRoles }
 * `me` is null while loading and when unauthenticated / the backend is unavailable.
 */
export function useMe() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!cached) cached = fetchMe();
    let alive = true;
    cached
      .then((v) => {
        if (!alive) return;
        setMe(v);
        setLoading(false);
        // Don't memoize a transient failure (e.g. backend not yet restarted) —
        // let the next mount re-fetch.
        if (!v) cached = null;
      })
      .catch(() => {
        if (!alive) return;
        setMe(null);
        setLoading(false);
        cached = null;
      });
    return () => { alive = false; };
  }, []);
  return { me, loading };
}

// Invalidate the cached /me (e.g. after a login/logout or auth-provider switch).
export function invalidateMe() {
  cached = null;
}
